/**
 * The text of every post, by slug and language. A post in `catalogue.ts` with no
 * body here — or a body with no entry there — fails `tests/blog.test.ts`.
 */
import type { Locale } from "@/i18n";
import type { PostBody } from "./types";
import { POST as ileRazyNagranie } from "./posts/ile-razy-nagranie";
import { POST as jednaCzescPonizejProgu } from "./posts/jedna-czesc-ponizej-progu";
import { POST as opowiadanieB1 } from "./posts/opowiadanie-b1";
import { POST as gramatykaB1 } from "./posts/gramatyka-b1";
import { POST as brakInformacjiB2 } from "./posts/brak-informacji-b2";
import { POST as ustnyTelcOcena } from "./posts/ustny-telc-ocena";
import { POST as ustnyPanstwowy } from "./posts/ustny-panstwowy";
import { POST as waznoscCertyfikatu } from "./posts/waznosc-certyfikatu";
import { POST as egzaminOnline } from "./posts/egzamin-online";
import { POST as dzienEgzaminu } from "./posts/dzien-egzaminu";
import { POST as przypadki } from "./posts/przypadki";
import { POST as czasowniki } from "./posts/czasowniki";
import { POST as liczebniki } from "./posts/liczebniki";
import { POST as poziomy } from "./posts/poziomy-a2-b1-b2";
import { POST as kartaPolaka } from "./posts/karta-polaka";
import { POST as testPoziomu } from "./posts/test-poziomu";
import { POST as ogloszenie } from "./posts/ogloszenie";
import { POST as zaproszenie } from "./posts/zaproszenie";
import { POST as egzaminC1 } from "./posts/egzamin-c1";
import { POST as panPani } from "./posts/pan-pani";
import { POST as trybRozkazujacy } from "./posts/tryb-rozkazujacy";
import { POST as czasPrzeszly } from "./posts/czas-przeszly";
import { POST as trybPrzypuszczajacy } from "./posts/tryb-przypuszczajacy";
import { POST as liczbaMnoga } from "./posts/liczba-mnoga";
import { POST as przymiotniki } from "./posts/przymiotniki";
import { POST as zaimki } from "./posts/zaimki";
import { POST as obywatelstwoWymagania } from "./posts/obywatelstwo-wymagania";
import { POST as bezEgzaminu } from "./posts/bez-egzaminu";
import { POST as rezydentUe } from "./posts/rezydent-ue";
import { POST as alfabet } from "./posts/alfabet";
import { POST as skarga } from "./posts/skarga";
import { POST as przyimkiMiejsca } from "./posts/przyimki-miejsca";
import { POST as pozdrowienia } from "./posts/pozdrowienia";
import { POST as zyczenia } from "./posts/zyczenia";
import { POST as sprawozdanie } from "./posts/sprawozdanie";
import { POST as esej } from "./posts/esej";
import { POST as charakterystyka } from "./posts/charakterystyka";
import { POST as recenzja } from "./posts/recenzja";
import { POST as listPrywatny } from "./posts/list-prywatny";
import { POST as listFormalny } from "./posts/list-formalny";
import { POST as reklama } from "./posts/reklama";
import { POST as opis } from "./posts/opis";
import { POST as zawiadomienie } from "./posts/zawiadomienie";
import { POST as rozprawka } from "./posts/rozprawka";

export const BODIES: Record<string, Record<Locale, PostBody>> = {
  "rozprawka": rozprawka,
  "zawiadomienie": zawiadomienie,
  "opis": opis,
  "reklama": reklama,
  "list-formalny": listFormalny,
  "list-prywatny": listPrywatny,
  "recenzja": recenzja,
  "charakterystyka": charakterystyka,
  "esej": esej,
  "sprawozdanie": sprawozdanie,
  "zyczenia": zyczenia,
  "pozdrowienia": pozdrowienia,
  "przyimki-miejsca": przyimkiMiejsca,
  "skarga": skarga,
  "alfabet": alfabet,
  "rezydent-ue": rezydentUe,
  "bez-egzaminu": bezEgzaminu,
  "zaimki": zaimki,
  "przymiotniki": przymiotniki,
  "liczba-mnoga": liczbaMnoga,
  "tryb-rozkazujacy": trybRozkazujacy,
  "czas-przeszly": czasPrzeszly,
  "tryb-przypuszczajacy": trybPrzypuszczajacy,
  "pan-pani": panPani,
  "egzamin-c1": egzaminC1,
  zaproszenie,
  ogloszenie,
  "test-poziomu": testPoziomu,
  "obywatelstwo-wymagania": obywatelstwoWymagania,
  "karta-polaka": kartaPolaka,
  "poziomy-a2-b1-b2": poziomy,
  liczebniki,
  czasowniki,
  przypadki,
  "dzien-egzaminu": dzienEgzaminu,
  "egzamin-online": egzaminOnline,
  "waznosc-certyfikatu": waznoscCertyfikatu,
  "ustny-panstwowy": ustnyPanstwowy,
  "ustny-telc-ocena": ustnyTelcOcena,
  "brak-informacji-b2": brakInformacjiB2,
  "gramatyka-b1": gramatykaB1,
  "opowiadanie-b1": opowiadanieB1,
  "jedna-czesc-ponizej-progu": jednaCzescPonizejProgu,
  "ile-razy-nagranie": ileRazyNagranie,
};
